.roles {
  display: flex;
}

.error input {
  background-color: var(--field-error);
}
.roles.error {
  color: var(--error);
}

.svg {
  display: flex;
}

.svg svg {
  width: 1rem;
  cursor: pointer;
}

.functionary {
  max-width: 350px;
}
